import { render, staticRenderFns } from "./SkillSearch.vue?vue&type=template&id=23df981b&scoped=true&"
import script from "./SkillSearch.vue?vue&type=script&lang=ts&"
export * from "./SkillSearch.vue?vue&type=script&lang=ts&"
import style0 from "./SkillSearch.vue?vue&type=style&index=0&id=23df981b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df981b",
  null
  
)

export default component.exports